import { ReactNode } from "react";
export interface IModalFooter {
  children: ReactNode;
}

function ModalFooter({children}: IModalFooter) {
  return (
    <div
      className="modal-footer px-0  d-block mt-lg-4 position-b pos-sticky"
      style={{ zIndex: 11 }}
    >
      {children}
    </div>
  );
}

export default ModalFooter;
